export const POST_LOGOUT_NOTICE_KEY = "post_logout_notice";

export const writePostLogoutNotice = (notice) => {
  try {
    sessionStorage.setItem(POST_LOGOUT_NOTICE_KEY, JSON.stringify(notice));
  } catch (error) {
    // Storage can be unavailable (private mode); the notice is best-effort.
  }
};

export const readPostLogoutNotice = () => {
  try {
    const raw = sessionStorage.getItem(POST_LOGOUT_NOTICE_KEY);
    if (!raw) {
      return null;
    }
    const notice = JSON.parse(raw);
    return notice?.type ? notice : null;
  } catch (error) {
    return null;
  }
};

export const clearPostLogoutNotice = () => {
  try {
    sessionStorage.removeItem(POST_LOGOUT_NOTICE_KEY);
  } catch (error) {
    // Storage can be unavailable (private mode); nothing to clean up then.
  }
};

/** Reads the notice and removes it, so it is shown exactly once. */
export const consumePostLogoutNotice = () => {
  const notice = readPostLogoutNotice();
  clearPostLogoutNotice();
  return notice;
};
